import { render, staticRenderFns } from "./ImportDetailInformationTab.vue?vue&type=template&id=4d2046aa&scoped=true&"
import script from "./ImportDetailInformationTab.vue?vue&type=script&lang=js&"
export * from "./ImportDetailInformationTab.vue?vue&type=script&lang=js&"
import style0 from "./ImportDetailInformationTab.vue?vue&type=style&index=0&id=4d2046aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2046aa",
  null
  
)

export default component.exports